const baseUrl = '';

export const environment = {
  production: false,
  baseUrl,
  version: 'v2.0.2-test',
  auth: {
    domain: 'siemens-qa-00169.eu.auth0.com',
    clientId: '1HO4uNTBO9Qjjr5iFxYQVg3dHHsq4vaN',
    authorizationParams: {
      audience: 'lcs-contract-dashboard-test',
      redirect_uri: window.location.origin,
    },
    errorPath: '/error',
    audience: 'lcs-contract-dashboard-test',
  },
  cacheLocation: 'localstorage',
  httpInterceptor: {
    allowedList: [`${baseUrl}/*`],
  },
  roles: {
    adminRole: 'LCS Contract Dashboard Test Admin',
    userRole: 'LCS Contract Dashboard Test User',
    orgaRole: 'LCS Contract Dashboard Test Management',
  },
};
